import React, { useState } from 'react';
import PageContainer from '../components/Layout/PageContainer';
import Card from '../components/UI/Card';
import Button from '../components/UI/Button';
import Badge from '../components/UI/Badge';
import { PlayCircle, Pause, Clock, CheckCircle, Plus } from 'lucide-react';

const Playbooks = () => {
  const [playbooks] = useState([
    { id: 1, name: 'Block Malicious IP', description: 'Automatically block IP addresses with high threat score', status: 'active', trigger: 'Threat Score > 80', lastRun: '2 hours ago' },
    { id: 2, name: 'Isolate Compromised Host', description: 'Isolate host from network when suspicious activity detected', status: 'active', trigger: 'Anomaly Detection', lastRun: '1 day ago' },
    { id: 3, name: 'Notify Security Team', description: 'Send alert to security team via webhook', status: 'active', trigger: 'Critical Event', lastRun: '30 min ago' },
    { id: 4, name: 'Scan New Asset', description: 'Run vulnerability scan on newly discovered assets', status: 'paused', trigger: 'New Asset Found', lastRun: '3 days ago' },
    { id: 5, name: 'Disable Compromised User', description: 'Disable user account after failed login threshold', status: 'active', trigger: '5+ Failed Logins', lastRun: '5 hours ago' },
  ]);

  const getStatusIcon = (status) => {
    if (status === 'active') return <CheckCircle className="w-4 h-4 text-success" />;
    return <Pause className="w-4 h-4 text-slate-400" />;
  };

  return (
    <PageContainer
      title="Playbooks"
      subtitle="Automated security response workflows"
      actions={
        <Button size="sm">
          <Plus className="w-4 h-4 mr-2" />
          Create Playbook
        </Button>
      }
    >
      <div className="grid gap-4">
        {playbooks.map((playbook) => (
          <Card key={playbook.id} className="hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                  playbook.status === 'active' ? 'bg-green-100' : 'bg-slate-100'
                }`}>
                  <PlayCircle className={`w-5 h-5 ${playbook.status === 'active' ? 'text-success' : 'text-slate-400'}`} />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900">{playbook.name}</h3>
                  <p className="text-sm text-slate-500">{playbook.description}</p>
                  <div className="flex items-center space-x-4 mt-2">
                    <span className="text-xs text-slate-400">
                      <Clock className="w-3 h-3 inline mr-1" />
                      Trigger: {playbook.trigger}
                    </span>
                    <span className="text-xs text-slate-400">
                      Last run: {playbook.lastRun}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Badge variant={playbook.status === 'active' ? 'success' : 'default'}>
                  {getStatusIcon(playbook.status)}
                  <span className="ml-1 capitalize">{playbook.status}</span>
                </Badge>
                <Button variant="outline" size="sm">
                  Edit
                </Button>
                <Button
                  variant={playbook.status === 'active' ? 'danger' : 'primary'}
                  size="sm"
                >
                  {playbook.status === 'active' ? 'Disable' : 'Enable'}
                </Button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </PageContainer>
  );
};

export default Playbooks;
